// @avantia common-code

import { HpEither } from '@avantia/logging-and-errors';
import { HpDynamicButtonClickAction } from '../actions/dynamicButtonClickActionTypes';
import { HpClientDebugFlags } from '../clientDebugFlags';
import { logError } from '../clientLogging';
import { getTypeOfQuestion } from '../reducers/questionSetTools';
import {
  HpClientCustomActionFunction,
  HpClientCustomActionFunctionProps,
  HpClientCustomActionResponse,
  HpClientQuestion,
  HpClientQuestionSetState,
  HpClientSection,
  HpDispatchFunction,
  HpEventTypes,
  HpFieldChangedPayload
} from '../types';
import { exceptionToString } from './clientAndServerUtilities';
import { HpClientPrerequisiteThisReferenceClass } from './prerequisiteThisReference';

export interface HpInvokeCustomScriptProps {
  customScript: HpClientCustomActionFunction;
  dispatch: HpDispatchFunction<unknown>;
  eventType: HpEventTypes;
  payload?: HpEither<HpFieldChangedPayload, HpDynamicButtonClickAction>;
  questionId: string;
  questionSet: HpClientQuestionSetState;
}

export function invokeCustomScript({
  customScript,
  dispatch,
  eventType,
  payload,
  questionId,
  questionSet
}: HpInvokeCustomScriptProps): HpClientCustomActionResponse {
  const { answers, answersId, commonLookups, displayState, productId, questions } = questionSet;
  const { sections } = displayState;
  const questionType = getTypeOfQuestion(questionId, questions, sections);
  const props: HpClientCustomActionFunctionProps = {
    answersId,
    dispatch,
    eventType,
    groupNumber: undefined,
    indexes: undefined,
    payload,
    questionId,
    questionType,
    sourceQuestionId: questionId
  };

  const self = new HpClientPrerequisiteThisReferenceClass<HpClientQuestion, HpClientSection>({
    answers,
    commonLookups,
    debugFlag: HpClientDebugFlags.ScriptActions,
    displayState,
    groupNumber: undefined,
    indexes: undefined,
    productId,
    questions,
    sections,
    sourceQuestionId: questionId,
    sourceQuestionType: questionType
  });

  let response: HpClientCustomActionResponse = false;
  try {
    response = customScript.call(self, props);
  } catch (ex) {
    logError(`Error calling custom script for '${questionId}' button: ${exceptionToString(ex)}`);
  }

  return response;
}
